import {
  IVerifonePurchaseTransactionExtendedData,
  isVerifonePurchaseTransactionExtendedData,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import {
  getRefundInfo$,
  getRefundLabel$,
  getRefundRemaining$,
} from '../../transaction-helpers';
import { VerifoneCardPurchaseTransactionProvider } from '../verifone-card-purchase-transaction-provider.service';

export class RefundVerifoneTransaction
  implements ITransactionAction<IVerifonePurchaseTransactionExtendedData>
{
  icon = 'undo';
  label = 'Refund';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isVerifonePurchaseTransactionExtendedData;

  constructor(private _provider: VerifoneCardPurchaseTransactionProvider) {}

  canDo$(
    data: ITransactionActionsData<IVerifonePurchaseTransactionExtendedData>
  ): Observable<boolean> {
    return getRefundRemaining$(data).pipe(
      map((remaining) => {
        const isIncoming = data.transaction.type === TransactionType.Incoming;
        const hasRemaining = remaining > 0;
        return isIncoming && hasRemaining;
      })
    );
  }

  label$(
    data: ITransactionActionsData<IVerifonePurchaseTransactionExtendedData>
  ): Observable<string> {
    return getRefundLabel$(data);
  }

  info$(
    data: ITransactionActionsData<IVerifonePurchaseTransactionExtendedData>
  ): Observable<string[]> {
    return getRefundInfo$(data);
  }

  async do(
    data: ITransactionActionsData<IVerifonePurchaseTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    try {
      await this._provider.refundTransaction(
        data.invoice,
        data.latestTransaction
      );
    } finally {
      this.inProgress$.next(false);
    }
  }
}
